export default __webpack_public_path__ + "static/media/wf-isf-expanded-goals-hero-mobile-v2.a6021893.jpg";